// extracted by mini-css-extract-plugin
module.exports = {"EditStockContainer":"EditStock_EditStockContainer__2PSuK","ButtonsContainer":"EditStock_ButtonsContainer__2m5H-","ButtonWrapper":"EditStock_ButtonWrapper__2mGSD"};